<template>
  <SupportBlock>
    <template
      v-slot:message
    >{{$t("banner.hireExpertDesc")}}</template>
    <template v-slot:action>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5592 12.0407L12.1335 17.4665L9.4668 17.9998L10.0001 15.3331L15.4259 9.90737C15.5655 9.76753 15.7313 9.65659 15.9139 9.58089C16.0964 9.50519 16.2921 9.46623 16.4897 9.46623C16.6873 9.46623 16.883 9.50519 17.0655 9.58089C17.2481 9.65659 17.4139 9.76753 17.5535 9.90737L17.5592 9.91306C17.6991 10.0527 17.81 10.2185 17.8857 10.4011C17.9614 10.5836 18.0004 10.7793 18.0004 10.9769C18.0004 11.1745 17.9614 11.3702 17.8857 11.5527C17.81 11.7353 17.6991 11.9011 17.5592 12.0407V12.0407Z"
          stroke="#0060E5"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.33332 15.8666H3.06666C2.78377 15.8666 2.51246 15.7543 2.31242 15.5542C2.11238 15.3542 2 15.0829 2 14.8V3.06666C2 2.78377 2.11238 2.51246 2.31242 2.31242C2.51246 2.11238 2.78377 2 3.06666 2H13.7333C14.0162 2 14.2875 2.11238 14.4876 2.31242C14.6876 2.51246 14.8 2.78377 14.8 3.06666V7.86666"
          stroke="#0060E5"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.39934 13.7333H5.19935C5.0579 13.7333 4.92224 13.6771 4.82222 13.5771C4.72221 13.4771 4.66602 13.3414 4.66602 13.2V10.5333C4.66602 10.3919 4.72221 10.2562 4.82222 10.1562C4.92224 10.0562 5.0579 9.99998 5.19935 9.99998H12.1327"
          stroke="#0060E5"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.5993 4.13333H5.19935C4.9048 4.13333 4.66602 4.37211 4.66602 4.66666V7.33333C4.66602 7.62788 4.9048 7.86666 5.19935 7.86666H11.5993C11.8939 7.86666 12.1327 7.62788 12.1327 7.33333V4.66666C12.1327 4.37211 11.8939 4.13333 11.5993 4.13333Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M11.5993 4.1333H5.19935C4.9048 4.1333 4.66602 4.37208 4.66602 4.66663V7.33329C4.66602 7.62785 4.9048 7.86663 5.19935 7.86663H11.5993C11.8939 7.86663 12.1327 7.62785 12.1327 7.33329V4.66663C12.1327 4.37208 11.8939 4.1333 11.5993 4.1333Z"
          stroke="#0060E5"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="8.34529"
            y1="2.48343"
            x2="5.51042"
            y2="8.15317"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ECF3FE" />
            <stop offset="1" stop-color="#C6DAFD" />
          </linearGradient>
        </defs>
      </svg>
      {{$t("banner.hireExpertDesc")}}
    </template>
  </SupportBlock>
</template>

<script>
import SupportBlock from "../SupportBlock";
export default {
  name: "HireExpert",
  components: {
    SupportBlock
  }
};
</script>
